<template>
<div class="container-fluid">
  <b-row class="row">
    <b-col
        class="col-md-5 no-padding d-none d-sm-none	d-md-none d-md-block content1 text-right"
        >
        <img 
            style="width:500px;"
            class="m-3" 
            src="https://www.enterprisepanama.com/img/imagenes_standard_of_care/generic-standard-of-care-640x360-green.png"/>
        
    </b-col>
    <b-col class="col-md-7 d-none d-sm-none	d-md-none d-md-block content1" style="padding-right: 18%;">
      <div  class="ml-3">
        <h3 class="titletext text-uppercase">{{$t('main_content.title_covid')}}</h3>
        <h2 class="subtext text-capitalize">{{$t('main_content.text_covid')}}</h2>
       </div>
       <div class="mt-5">
       <router-link :to="{ name: 'Covid19'}">
        <a 
        role="button"
        href="" 
        class="ml-3 btn btn-primary rounded-0 shadow-none text-uppercase">{{$t('buttons_label.get_info')}}
        </a>
       </router-link> 
       </div>
    </b-col>
  </b-row>
  <b-row>
    <!-- mobile img -->
    <b-col md
        class="content1 d-md-none d-lg-none d-xl-none no-padding"
        >
         <img 
            style="width:100%"
            class="" 
            src="https://www.enterprisepanama.com/img/imagenes_standard_of_care/generic-standard-of-care-640x360-green.png"/>
    </b-col>
    <b-col md class="bggreen d-md-none d-lg-none d-xl-none">
      <div  class="ml-3">
        <h3 class="titletext text-uppercase">{{$t('main_content.title_covid')}}</h3>
        <h6 class="subtext text-capitalize">{{$t('main_content.text_covid')}}</h6>
      </div>
      <br><br><br><br>
      <div class="">
       <a 
       style="margin-top: 0px"
        role="button"
        href="" 
        class="ml-3 btn btn-primary rounded-0 shadow-none text-uppercase">{{$t('buttons_label.get_info')}}
        </a>
        
      </div>
      <br><br>
    </b-col>
    <!-- end mobile -->
  </b-row>
  <br><br>
  <!-- second content -->
  <b-row class="ml-1 mr-1">
    <b-col md>
     <div class="mt-5">
     <h4 class="titlesection text-capitalize">{{$t('masternav.leasing_ope')}}</h4>
     <img 
     style="width:100%; height:auto; "
     class="mt-4" 
     src="/img/leasingtruck.jpeg"/>
     <h5 class="textpromo mt-3">{{$t('main_content.leasing_text')}}</h5>
     <router-link :to="{ name: 'Leasing'}">
     <b-button 
     squared 
     class="button2 mt-3 text-uppercase" 
     href="">{{$t('buttons_label.learn_more')}}
     </b-button>
     </router-link>
     <br>
     </div>
    </b-col>
    
    <!--<b-col md>
     <div class="mt-5">
     <h4 class="titlesection text-center text-capitalize">{{$t('main_content.promo_weekend')}}</h4>
     <img 
     style="width:100%; height:auto; "
     class="mt-4" 
     src="/img/Paquete4D.jpg"/>
     <h5 class="textpromo mt-3">{{$t('main_content.promo_week_text')}}</h5>
     <b-button squared class="button2 mt-3" router-link :to="{ name: 'Pack4d'}">{{$t('buttons_label.reserve_now')}}</b-button>
     <br>
     </div>
    </b-col>-->
    <b-col md>
     <div class="mt-5">
     <h4 class="titlesection">{{$t('main_content.monthly_title')}}</h4>
     <img 
     style="width:63%; height:auto; "
     class="mt-4" 
     src="/img/alquileres-mensuales-de-autos.jpg"/>
     <h5 class="textpromo mt-3">{{$t('main_content.monthly_text')}}</h5>
     <b-button squared class="button2 mt-3" router-link :to="{ name: 'Bymonth'}">{{$t('buttons_label.reserve_now')}}</b-button>
     <br>
     </div>
    </b-col>
  </b-row>
  <!-- third contet -->
  <br><br><br>
  <b-row>
    <b-col
        class="d-none d-sm-none	d-md-none d-md-block "
        style="
        max-height: 100%;
        max-width: 100%
        background-position: center top;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url('../img/stpcars2.png');"
        >
    </b-col>
    <b-col class="d-none d-sm-none	d-md-none d-md-block content3">
      <div  class="ml-3">
        <h3 class="titletext text-capitalize">{{$t('main_content.company_solutions')}}</h3>
        <h2 class="subtext">{{$t('main_content.company_text')}}</h2>
       </div>
       <div class="mt-5">
       <router-link :to="{ name: 'Leasing'}">
       <b-button 
       squared 
       class="button2 mt-3 ml-3" 
       href="">{{$t('buttons_label.learn_more')}}
       </b-button>
       </router-link>
       </div>
    </b-col>
  </b-row>
  <b-row>
    <!-- mobile img -->
    <b-col md
        class="content3 d-md-none d-lg-none d-xl-none"
        style="
        max-height: 250px;
        max-width: 100%
        background-position: fixed;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url('../img/stpcars2.png');"
        >
    </b-col>
    <b-col md class="bggreen d-md-none d-lg-none d-xl-none">
      <div  class="ml-3">
        <h3 class="titletext">{{$t('main_content.company_solutions')}}</h3>
        <h6 class="subtext">{{$t('main_content.company_text')}}</h6>
      </div>
      <br><br><br><br><br><br><br><br>
      <div class="">
       <a 
       style="margin-top: 0px"
        role="button"
        href="" 
        class="ml-3 btn btn-primary rounded-0 shadow-none text-uppercase">{{$t('buttons_label.get_info')}}
        </a>
        
      </div>
      <br><br>
    </b-col>
    <!-- end mobile -->
  </b-row>
  <!-- fourth content carousel -->
    <div>
      <br><br>
       <h1 class="titlequestion text-center text-uppercase">{{$t('main_content.fleet_carousel')}}</h1>
       <h6 class="textpromo text-center">{{$t('main_content.carousel_text')}}</h6>
    <div id="carouselExampleCaptions" class="carousel slide text-center d-none d-sm-none d-md-block" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
        <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
        <li data-target="#carouselExampleCaptions" data-slide-to="3"></li>
        <li data-target="#carouselExampleCaptions" data-slide-to="4"></li>
      </ol>
      <!-- fleet -->
      <div class="carousel-inner mt-5">
        <!-- auto 1 -->
        <div class="carousel-item text-center active">
          <img 
          src="/img/picantostd.png" 
          class="text-center" 
          alt="..."
          
          style="width:640px; heigth:480px;"
          >
          <br><br><br><br><br><br>
          <div class="carousel-caption d-none d-md-block mt-5">
            <h5 class="titlecar text-capitalize">{{$t('main_content.cars')}}</h5>
            <p class="textpromo">{{$t('main_content.cars_text')}}</p>
          </div>
        </div>
        <!-- auto 2 -->
        <div class="carousel-item text-center">
          <img 
          src="/img/cretastd.png" 
          class="text-center" 
          alt="..."
          
          style="width:640px; heigth:480px;"
          >
          <br><br><br><br><br><br>
          <div class="carousel-caption d-none d-md-block mt-5">
            <h5 class="titlecar text-capitalize">{{$t('main_content.suv')}}</h5>
            <p class="textpromo">{{$t('main_content.suv_text')}}</p>
          </div>
        </div>
        <!-- auto 3 -->
        <div class="carousel-item text-center">
          <img 
          src="/img/carnivalstd.png" 
          class="text-center" 
          alt="..."
          
          style="width:640px; heigth:480px;"
          >
          <br><br><br><br><br><br>
          <div class="carousel-caption d-none d-md-block mt-5">
            <h5 class="titlecar text-capitalize">{{$t('main_content.van')}}</h5>
            <p class="textpromo">{{$t('main_content.van_text')}}</p>
          </div>
        </div>
        <!-- auto 4 -->
        <div class="carousel-item text-center">
          <img 
          src="/img/hiluxstd.png" 
          class="text-center" 
          alt="..."
          
          style="width:640px; heigth:480px;"
          >
          <br><br><br><br><br><br>
          <div class="carousel-caption d-none d-md-block mt-5">
            <h5 class="titlecar text-capitalize">{{$t('main_content.comercial')}}</h5>
            <p class="textpromo">{{$t('main_content.comercial_text')}}</p>
          </div>
        </div>
        <!-- auto 5 -->
        <div class="carousel-item text-center">
          <img 
          src="/img/hino300std.jpg" 
          class="text-center" 
          alt="..."
          
          style="width:640px; heigth:480px;"
          >
          <br><br><br><br><br><br>
          <div class="carousel-caption d-none d-md-block mt-5">
            <h5 class="titlecar text-capitalize">{{$t('main_content.trucks')}}</h5>
            <p class="textpromo">{{$t('main_content.trucks_text')}}</p>
          </div>
        </div>
        <br>
      </div>

      <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon bg-secondary" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
        <span class="carousel-control-next-icon bg-secondary" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
      <!-- fleet mobile -->
      <div class="d-md-none d-lg-none d-xl-none">
        <b-carousel
          id="carousel-no-animation"
          style="text-shadow: 0px 0px 2px #000"
          fade
          indicators
          img-width="1024"
          img-height="480"
        >
          <b-carousel-slide
            caption="Autos"
            img-src="/img/picantostd.png"
          ></b-carousel-slide>
          <b-carousel-slide
            caption="SUV's"
            img-src="/img/cretastd.png"
          ></b-carousel-slide>
          <b-carousel-slide
            caption="Van"
            img-src="/img/carnivalstd.png"
          ></b-carousel-slide>
          <b-carousel-slide
            caption="Comercial"
            img-src="/img/hiluxstd.png"
          ></b-carousel-slide>
          <b-carousel-slide
            caption="Camiones"
            img-src="/img/hino300std.jpg"
          ></b-carousel-slide>
        </b-carousel>
      </div>
      <!--  -->
      <br>
    <!-- button fleet -->
    <div class="text-center" style="">
       <router-link :to="{ name: 'Fleet'}">
       <b-button 
       squared 
       class="button2 text-uppercase" 
       href="">{{$t('buttons_label.view_fleet')}}
       </b-button>
       </router-link>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'maincontent',
    data() {
      return {
        slide: 0,
        sliding: null
      }},
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
}
</script>

<style scoped lang="scss">
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
    
}
.no-padding {
  padding-left: 0;
  padding-right: 0;
}
.carousel-indicators li {
    background-color: #686e6b !important;
    height: 5px !important;
    width: 40px !important;
    margin-top: 40px !important;
}

.carousel-indicators .active {
    background-color: #169A5A !important;
    height: 8px !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   
   color: #181918;
   font-weight: 600;
}
.textpromo{
  color: #333333; 
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 17px;
  font-weight: 300;
}
.titlecar{
  color: #181918; 
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  font-size: 21px;
  font-weight: 800;
}
.imgcontent1{
    width: 100%;
    height: 100%;
}
.bggreen{
    background: #169A5A;
}
.content1{
    height: auto; 
    background: #169A5A;
}
.content3{
    height: 500px; 
    background: #181918;
}
.titletext{
    font-family: 'DIN 2014-Regular';
    color: rgb(255, 255, 255);
    font-size: 32px;
    font-weight: 700;
    /* height: 37px;
    line-height: 37.3333px; */
    
    margin-top: 70px;
/*         text-transform: none;
        -webkit-text-size-adjust: 100%;
            
            min-height: auto; */
            display: inline-block;
}
.subtext{
    font-family: 'DIN 2014-Regular';
    color: rgb(255, 255, 255);
    font-size: 24px;
    font-weight: 600;
    height: 92px;
    line-height: 28px;

}

.btn-primary {
  background-color: rgb(255, 255, 255); /* Green */
  border: 1px solid rgb(255, 255, 255);
  color: #169A5A;

  font-size: 14px;
  font-weight: 700;
  height: 35px;

}
.btn-primary:hover {
  background-color: #169A5A;
  color: rgb(255, 255, 255);
  border: 1px solid rgb(255, 255, 255) !important;
  border-color: rgb(255, 255, 255);
  
}
.btn-primary:active{
  background-color: #169A5A !important;
  color: rgb(255, 255, 255) !important;
  border: 1px solid rgb(255, 255, 255) !important;
  border-color: rgb(255, 255, 255) !important;

}
.btn-primary:focus{
  background-color: #169A5A;
  color: rgb(255, 255, 255);
  border: 1px solid rgb(255, 255, 255);
  border-color: rgb(255, 255, 255);
}
.button2{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  color: #FFFFFF;
  size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  background: #169A5A;
  height: 42px;
  border: none;
}
.button2:hover{
  background:#006639;
}
.olmargin{
  margin-top: 20px;
}
</style>
